import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// import { AppState } from '@capacitor/app';
import { setLoadingSpinner } from '../actions/shared.action';
import { catchError, exhaustMap, filter, map, mergeMap, of, tap } from 'rxjs';
import { ROUTER_NAVIGATION, RouterNavigatedAction } from '@ngrx/router-store';
import * as fromStudentActions from '../actions/student.action'
import { APIResponse } from 'src/app/models/api-response.model';
import { AppState } from '../app.state';
import { SchoolService } from 'src/app/services/school.service';
import { StudentService } from 'src/app/services/student.service';
import * as fromSharedActions from '../actions/shared.action'
import { ModalService } from 'src/app/services/modal.service';
import { SharedService } from 'src/app/services/shared.service';

@Injectable()
export class SharedEffects {

  setLoadingSpinner$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromSharedActions.setLoadingSpinner),
        tap(async (action) =>{
          if(action.status){
            this.modalService.showLoadingSpinner()
          } else{
            this.modalService.hideLoadingSpinner()
          }
        })
      ),
    { dispatch: false }
  );

  getDashboardWidgets$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(ROUTER_NAVIGATION),
        filter((r : RouterNavigatedAction) => {
          return r.payload.routerState.url.startsWith('/home/dashboard');
        }),
        exhaustMap((action) =>
          this.sharedService.getDashboardWidgets().pipe(
            map((response) => { 
              console.log('getDashboardWidgets$', response);
              return fromSharedActions.getDashboardWidgetsSuccess({ data: response?.details});
            }),
            catchError((response) => {
              return of(fromSharedActions.getDashboardWidgetsFailed({ data: response.error }));
            })
          )
        )
      )
    },
    { dispatch: false });

  constructor(
    private actions$: Actions,
    private modalService: ModalService,
    private sharedService: SharedService
  ) {}

}
